import { useInstitution } from '../contexts/InstitutionContext';

// Ações liberadas pro usuário logado dentro de uma tela específica, NA
// INSTITUIÇÃO ATIVA (ver recursos_permitidos em backend/auth.js — GET
// /minhas-permissoes — e a tela de Permissões, que agora configura isso por
// instituição). Master sempre tem tudo liberado (o backend já devolve assim).
// Perfil sem nada configurado pra essa tela também tem tudo liberado por
// padrão (o backend só manda o que falta quando o master bloqueia algo de
// propósito) — por isso a ausência de uma entrada aqui é tratada como
// liberado, nunca como bloqueado.
export function usePermissao(tela) {
  const { permissoes } = useInstitution();
  const recursos = permissoes?.recursos_permitidos?.[tela];
  const tem = (recurso) => !recursos || recursos.includes(recurso);

  return {
    podeVisualizar: tem('visualizar'),
    podeCriar: tem('criar'),
    podeEditar: tem('editar'),
    podeExcluir: tem('excluir'),
    podeExportar: tem('exportar'),
  };
}
